export const DEFAULT_ORG_START_PAGE_ROUTE = ['documents', 'list', 'kind'];
